import React, { useEffect, useRef, createElement } from 'react';
import { CountdownBanner } from './components/CountdownBanner';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { MethodIntro } from './components/MethodIntro';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
import { FooterSection } from './components/FooterSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  const pixelLoaded = useRef(false);
  useEffect(() => {
    if (pixelLoaded.current) return;
    pixelLoaded.current = true;
    const w = window as any;
    if (w.fbq) return;
    const n: any = w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
    w.fbq('init', '1272637858178142');
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 antialiased selection:bg-yellow-200 selection:text-gray-900" data-id="element-0">
      <CountdownBanner data-id="element-1" />

      <main className="flex flex-col w-full overflow-hidden" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <MethodIntro data-id="element-5" />
        <TomosSection data-id="element-6" />
        <BonusSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <ClosingSection data-id="element-11" />
      </main>

      <FooterSection data-id="element-12" />

      <SocialProofPopup data-id="element-13" />
    </div>;
}